export const data = {
  product: {
    title: 'Has the seller attempted to repair/replace the Item?',
    image:
      'https://media.product.which.co.uk/prod/images/original/f03d6c591f16-tooliconkettlewarning.jpg',
  },
  damagedDevice: {
    title: 'Has the seller attempted to repair/replace the content & device?',
    image:
      'https://media.product.which.co.uk/prod/images/original/c75cd4e69e2c-tooliconspanner.jpg',
  },
  content: {
    title: 'Has the seller attempted to repair/replace the content?',
    image:
      'https://media.product.which.co.uk/prod/images/original/17e8c254418b-tooliconbagquestion.jpg',
  },
  title: 'What item did you order?',
  imageAlt: '',
  buttons: [
    {
      label: 'Yes',
      id: 'yes',
    },
    {
      label: 'No',
      id: 'no',
    },
  ],
}
